var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "calendar-title-style" },
    [
      _c(_setup.CalendarFontField, {
        attrs: { value: _vm.config[_setup.keys.font], disabled: _vm.disabled },
        on: {
          input: function ($event) {
            return _setup.update(_setup.keys.font, $event)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(_setup.CInput, {
            class: _setup.alignKey ? "col-4" : "col-6",
            attrs: {
              value: Number(_vm.config[_setup.keys.size]),
              type: "decimal",
              step: ".1",
              min: 0,
              label: "Font size (pts)",
              disabled: _vm.disabled,
            },
            on: {
              input: function ($event) {
                _setup.update(_setup.keys.size, String($event))
              },
            },
          }),
          _vm._v(" "),
          _c(_setup.CInput, {
            class: _setup.alignKey ? "col-4" : "col-6",
            attrs: {
              value: Number(_vm.config[_setup.keys.margin]),
              type: "decimal",
              step: ".1",
              min: 0,
              label: "Top Margin",
              disabled: _vm.disabled,
            },
            on: {
              input: function ($event) {
                _setup.update(_setup.keys.margin, String($event))
              },
            },
          }),
          _vm._v(" "),
          _setup.alignKey
            ? _c(_setup.CSelect, {
                staticClass: "col-4",
                attrs: {
                  value: _setup.align,
                  options: _setup.ALIGN_OPTIONS,
                  "model-transform": _setup.valueReducer,
                  clearable: false,
                  label: "Horizontal Alignment",
                  disabled: _vm.disabled,
                },
                on: {
                  input: function ($event) {
                    return _setup.update(_setup.alignKey, $event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.CalendarColorField, {
        attrs: {
          title: "Font Color",
          value: _vm.config[_setup.keys.color],
          disabled: _vm.disabled,
        },
        on: {
          input: function ($event) {
            return _setup.update(_setup.keys.color, $event)
          },
        },
      }),
      _vm._v(" "),
      _c(_setup.CalendarStrokeField, {
        attrs: {
          width: _vm.config[_setup.keys.strokeWidth],
          color: _vm.config[_setup.keys.strokeColor],
          disabled: _vm.disabled,
        },
        on: { update: _setup.onStrokeUpdate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }